{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Παρακαλώ εισάγετε το email σας.",
      "ERROR": "Παρακαλώ εισάγετε ένα έγκυρο email."
    },
    "API": {
      "SUCCESS_MESSAGE": "Σύνδεσμος για την επαναφορά του κωδικού έχει αποσταλεί στο email σας.",
      "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
    },
    "SUBMIT": "Καταχώρηση"
  }
}
